export const unixToMilliseconds = (unix) => {

  return unix * 1000;

};
